import React, { useEffect, useState, useRef } from 'react';
import { useServiceContext } from '../../components/Context/ServiceContext';
import { useBranchContext } from '../../components/Context/BranchContext';
import { useSnackbar } from '.././SnackBar';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import ConfirmDialog from '../../views/ConfirmDialog';
import { Tabs, Tab, Box, Typography, Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
// import TabContext from '@mui/lab/TabContext';
// import TabList from '@mui/lab/TabList';

//import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useNavigate } from 'react-router-dom';
import { TextField, InputAdornment, IconButton, Dialog, DialogTitle, DialogContentText, DialogActions, DialogContent } from '@mui/material';



const EditServiceView = () => {

    const navigate = useNavigate()
    const { showSnackbar } = useSnackbar();
    const { Updateservice, service, additionalService, FetchServiceCategory, FetchAdditionalService, serviceCategory, AddService, EditService } = useServiceContext();
    const { branches, FetchBranches } = useBranchContext();
    const nameRef = useRef('');
    const categoryRef = useRef('');
    const priceRef = useRef('');
    const descriptionRef = useRef('');
    const imageUrlRef = useRef('');
    const statusRef = useRef('');
    const [selectedFile, setSelectedFile] = useState(null);
    // const [items, setItems] = useState([]);
    const [isDiscountEnabled, setIsDiscountEnabled] = useState(false);
    const [discount, setDiscount] = useState(Updateservice.discountPercentage || '');
    const [homeServiceEnabled, setHomeServiceEnabled] = useState(false);
    const [serviceCharge, setServiceCharge] =  useState(Updateservice.serviceCharge || '');
    const serviceChargeRef = useRef(null);
console.log(Updateservice);
    const discountRef = useRef();
    const isPeriodicRef = useRef(false);
    const isQuickSelectRef = useRef(false);
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]); // Get the first selected file
    };

    const handleAddService = async () => {
         
        const Name = nameRef.current.value;
        const price = priceRef.current.value;
        const description = descriptionRef.current.value;
        const imageUrl = imageUrlRef.current.value;
        const status = statusRef.current.checked;
        const discountPercentage = isDiscountEnabled?discountRef.current.value:0;
        const  serviceCharge=homeServiceEnabled ? serviceChargeRef.current.value : 0
        if (Name === '' || price === '' || serviceCatergoryId === '') {
            showSnackbar('Service name/Price/ServiceCategory cannot be empty.');
            return;
        }



        try {
            const servicedata = {
                id: Updateservice.id,
                name: Name,
                serviceCategoryId: parseInt(serviceCatergoryId),
                price: price,
                description: description,
                imageUrl: imageUrl,
                branchId: selectedbranches,
                additionalServiceId: selectedAddSer,
                isActive: status,
                finalPrice: 0,
                discounted: isDiscountEnabled,
                 homeServiceEnabled:homeServiceEnabled,
                serviceCharge:serviceCharge,
                discountPercentage: discountPercentage,
                isApproved: Updateservice.isApproved,
                isPeriodic: isPeriodicRef.current?.checked || false,
                isQuickSelect: isQuickSelectRef.current?.checked || false,
                isFeatured: Updateservice.isFeatured,
            };
            
            const p =  await EditService(servicedata, selectedFile);

            showSnackbar('Service Updated successfully!'); // Notify success
            navigate(`/partnerservice`);
            setTimeout(() => {
                // navigate(`/editpartnerservice/${p.id}/false`);
            }, 2000); // Adjust delay as needed
        } catch (error) {
            showSnackbar('Error Updating Service. Please try again.');
            console.error('Error Updating Service:', error);
        }
    };

    const [additionalName, setAdditionalName] = React.useState([]);
    const [branchName, setBranchName] = React.useState([]);
    const theme = useTheme();
    const [selectedbranches, setBranches] = React.useState([]);
    const [selectedAddSer, setAddServ] = useState([]);

    const handleAddServChange = (event) => {
        const {
            target: { value },
        } = event;
        setAdditionalName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        const strvalue = value.map(num => num.toString());
        setAddServ(strvalue); // Store selected IDs
    };

    const [open, setOpen] = useState(false);
    const handleActivateService = (event) => {
        const isActive = event.target.checked;
        Updateservice.isActive = isActive;
        setOpen(true); // Open the confirmation dialog
    };

    const handleClose = () => {
        Updateservice.isActive = Updateservice.isActive ? false : true
        setOpen(false); // Close the confirmation dialog
    };

    const handleConfirm = () => {

        setOpen(false); // Close the confirmation dialog
    };

    const handleBranchChange = (event) => {
        const {
            target: { value },
        } = event;
        setBranchName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        const strvalue = value.map(num => num.toString());
        setBranches(strvalue);
    };

    const [serviceCatergoryId, setCategoryId] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState([]); // Default selected value (e.g., "1")
    const handleCategorychange = (event) => {
        const value = `${event.target.value}`;
        setCategoryId(value);
        setSelectedCategory(value);
    };


    const handleDelete = (event, value) => {

        alert(1)
    };
    const didFetch = useRef(false);
    const getData = async () => {
        try {
            await FetchServiceCategory();

            await FetchAdditionalService();
            await FetchBranches();
            isPeriodicRef.current.checked = Updateservice.isPeriodic;
            if (isQuickSelectRef.current) {
                isQuickSelectRef.current.checked = !!Updateservice.isQuickSelect;
            }
            const BranchArray = Updateservice.branch.map(item => item.id);
            BranchArray.forEach(element => {
                setBranchName((prevBranches) => [...prevBranches, element]);
                setBranches((prevBranches) => [...prevBranches, element.toString()]);
            });
            const AddserviceArray = Updateservice.additionalServices.map(item => item.id);
            AddserviceArray.forEach(element => {
                setAdditionalName((prevBranches) => [...prevBranches, element]);
                setAddServ((prevBranches) => [...prevBranches, element.toString()]);
            });

            setSelectedCategory(Updateservice.serviceCategoryId);
            setCategoryId(Updateservice.serviceCategoryId);
             
            setIsDiscountEnabled(Updateservice.discounted);
            setHomeServiceEnabled(Updateservice.homeServiceEnabled);

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {

        if (!didFetch.current) {
            getData();
            didFetch.current = true; // Mark the API call as done

            console.log(serviceCategory);
        }

    });
    const handleToggleDiscount = () => {
        setIsDiscountEnabled(!isDiscountEnabled);
    };

    const handleDiscountChange = (event) => {
        setDiscount(event.target.value);
    };

    
      
      const handleToggleHomeService = () => {
        setHomeServiceEnabled((prev) => !prev);
      };
      
      const handleServiceChargeChange = (event) => {
        setServiceCharge(event.target.value);
        
      };
        const [confirmIsPeriodicRefStatusOpen, setConfirmIsPeriodicRefStatusOpen] = useState(false);
        const [previousIsPeriodicValue, setPreviousIsPeriodicValue] = useState(false);
        const handleIsPeriodicActive = () => {
          if (isPeriodicRef.current) {
            const current = isPeriodicRef.current.checked;
            // Save previous value before showing dialog
            setPreviousIsPeriodicValue(!current); // Store old state
            setConfirmIsPeriodicRefStatusOpen(true); // Open dialog
          }
        };
        const handleIsPeriodicConfirmStatusChange = () => {
          const isChecked = isPeriodicRef.current?.checked || false;
          // Perform your update logic here (API call, state update, etc.)
          console.log('Status changed to:', isChecked ? 'Enabled' : 'Disabled');
      
          setConfirmIsPeriodicRefStatusOpen(false);
        };
        const handleIsPeriodicStatusDialogClose = () => {
          if (isPeriodicRef.current) {
            isPeriodicRef.current.checked = previousIsPeriodicValue;
          }
          setConfirmIsPeriodicRefStatusOpen(false); // Close the dialog
        };
    var styles = { inputDisabled: { border: 'none', background: 'none' } };
    return (
        <div>
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Service</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                            <li className="breadcrumb-item"><a href='/partnerservice'>Services</a></li>
                            <li className="breadcrumb-item active"><a href=''>Edit Service</a></li>
                        </ol>
                    </nav>
                </div>
                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h5 className="card-title">New Service Details</h5>
                                    <div>

                                        <div className="row mb-3">
                                            <label htmlFor="inputText" className="col-sm-2 col-form-label">Name</label>
                                            <div className="col-sm-10">
                                                <input type="text" className="form-control" style={styles.inputDisabled}defaultValue={Updateservice.name} ref={nameRef}></input>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Service Category</label>
                                            <div className="col-sm-6">
                                                <FormControl fullWidth sx={{ width: '300px' }}>
                                                    {serviceCategory && <Select id="fruits" name="fruits" className="form-control" value={selectedCategory} onChange={handleCategorychange}
                                                        sx={{
                                                            width: "300px",           // Adjust width as needed
                                                            // Rounded corners
                                                            "& .MuiOutlinedInput-root": {

                                                            },
                                                            "& .MuiSelect-select": {
                                                                padding: "8px 12px",     // Adjust padding
                                                            },
                                                        }}                                                        >
                                                        {serviceCategory.map((category) => (
                                                            <MenuItem key={category.serviceCategoryId} value={category.serviceCategoryId} selected={category.serviceCategoryId == "1" ? "true" : "false"}>
                                                                {category.serviceCategoryName}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    }
                                                </FormControl>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="phone" className="col-sm-2 col-form-label">Price:</label>
                                            <div className="col-sm-10">
                                                <input type="tel" id="phone" name="phone" className="form-control" required defaultValue={Updateservice.price} ref={priceRef}></input>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputEmail" className="col-sm-2 col-form-label">Description</label>
                                            <div className="col-sm-10">
                                                <input type="email" className="form-control" defaultValue={Updateservice.description} ref={descriptionRef} ></input>
                                            </div>
                                        </div>
                                        {
                                            Updateservice.imageUrl !== "" &&
                                            <div className="row mb-3">
                                                <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Image</label>
                                                <div className="col-sm-10">
                                                    <img height="200px" width="200px" alt="" src={Updateservice.imageUrl}></img>

                                                </div>
                                            </div>
                                        }
                                        <div className="row mb-3">
                                            <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Image</label>
                                            <div className="col-sm-6">
                                                <input className="form-control" type="file" id="formFile" onChange={handleFileChange} />
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Branch</label>
                                            <div className="col-sm-10">
                                                <FormControl fullWidth sx={{ width: '300px' }}>
                                                    <Select
                                                        labelId="demo-multiple-checkbox-label"
                                                        id="demo-multiple-checkbox"
                                                        multiple
                                                        value={branchName}
                                                        onChange={handleBranchChange}


                                                        renderValue={(selected) => (
                                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                {selected.map((value) => {
                                                                    // Find the name corresponding to the selected ID

                                                                    const selectedItem = branches.find(item => item.id === value);
                                                                    return (
                                                                        <Chip
                                                                            key={value}
                                                                            label={selectedItem?.name}

                                                                        />
                                                                    );
                                                                })}
                                                            </Box>
                                                        )}

                                                        sx={{
                                                            width: "300px",           // Adjust width as needed
                                                            // Rounded corners
                                                            "& .MuiOutlinedInput-root": {

                                                            },
                                                            "& .MuiSelect-select": {
                                                                padding: "8px 12px",     // Adjust padding
                                                            },
                                                        }}
                                                    >
                                                        {branches.map((value) => (
                                                            <MenuItem key={value.name} value={value.id}>
                                                                <Checkbox checked={branchName.includes(value.id)} />
                                                                <ListItemText primary={value.name} />
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>

                                        </div>
                                        <div className="row mb-3">
                                            <label htmlFor="inputPassword" className="col-sm-2 col-form-label">Additional Services</label>
                                            <div className="col-sm-10">


                                                <FormControl fullWidth sx={{ width: '300px' }}>
                                                    <Select
                                                        labelId="demo-multiple-checkbox-label"
                                                        id="demo-multiple-checkbox"
                                                        multiple
                                                        value={additionalName}
                                                        onChange={handleAddServChange}


                                                        renderValue={(selected) => (
                                                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                {selected.map((value) => {
                                                                    // Find the name corresponding to the selected ID

                                                                    const selectedItem = additionalService.find(item => item.id === value);
                                                                    return (
                                                                        <Chip
                                                                            key={value}
                                                                            label={selectedItem?.name}

                                                                        />
                                                                    );
                                                                })}
                                                            </Box>
                                                        )}

                                                        sx={{
                                                            width: "300px",           // Adjust width as needed
                                                            // Rounded corners
                                                            "& .MuiOutlinedInput-root": {

                                                            },
                                                            "& .MuiSelect-select": {
                                                                padding: "8px 12px",     // Adjust padding
                                                            },
                                                        }}
                                                    >
                                                        {additionalService.map((value) => (
                                                            <MenuItem key={value.name} value={value.id}>
                                                                <Checkbox checked={additionalName.includes(value.id)} />
                                                                <ListItemText primary={value.name} />
                                                            </MenuItem>
                                                        ))}
                                                    </Select>

                                                </FormControl>  </div>
                                        </div>


                      <div className="row mb-3">
                        <div className="col-md-4">
                          Mark as periodic service
                        </div>
                        <div className="col-md-8"  >
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="flexSwitchCheckDefault"
                              ref={isPeriodicRef}
                              onChange={handleIsPeriodicActive}
                            />
                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">

                              {isPeriodicRef.current?.checked ? 'Active' : 'Not Active'}
                            </label>
                          </div>
                        </div>


                        <Dialog open={confirmIsPeriodicRefStatusOpen} onClose={handleIsPeriodicStatusDialogClose}>
                          <DialogTitle>Confirm Status Change</DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              Are you sure you want to {isPeriodicRef.current?.checked ? 'activate' : 'deactivate'} for this service?
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleIsPeriodicStatusDialogClose} color="secondary">
                              Cancel
                            </Button>
                            <Button onClick={handleIsPeriodicConfirmStatusChange} color="primary" autoFocus>
                              Confirm
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </div>

                      <div className="row mb-3">
                        <div className="col-md-4">
                          Quick select in partner app
                        </div>
                        <div className="col-md-8">
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="quickSelectSwitchEdit"
                              ref={isQuickSelectRef}
                            />
                            <label className="form-check-label" htmlFor="quickSelectSwitchEdit">
                              Show as one-tap service on order screen
                            </label>
                          </div>
                        </div>
                      </div>


                                        <div className="form-check form-switch">
                                            {!Updateservice.isApproved && <div className="row mb-3">
                                                <label htmlFor="Approval Status" >Service not approved by ADMIN  !</label>
                                                    </div>}
                                            {Updateservice.isApproved && <div><input className="form-check-input" type="checkbox" checked={Updateservice.isActive} id="flexSwitchCheckDefault" defaultValue={Updateservice.status} ref={statusRef} onChange={handleActivateService}></input>
                                                <label className="form-check-label" htmlFor="flexSwitchCheckDefault" >Activate/Deactivate Service</label></div>}
                                        </div>
                                        <ConfirmDialog
                                            open={open}
                                            onClose={handleClose}
                                            onConfirm={handleConfirm}
                                            title="Confirm Deactivate/Activate"
                                            content="Are you sure you want to Deactivate/Activate this Service?"
                                        />
                                       
                                        <div className="form-check form-switch mb-3">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="toggleDiscount"
                                                onChange={handleToggleDiscount}
                                                checked={isDiscountEnabled}
                                            />
                                            <label className="form-check-label" htmlFor="toggleDiscount">
                                                Enable Discount
                                            </label>
                                        </div> {isDiscountEnabled && (
                                            <div className="row mb-3">
                                                <label htmlFor="discount" className="col-sm-2 col-form-label">Discount (%):</label>
                                                <div className="col-sm-6">
                                                    <input
                                                        type="text"  value={discount ?? Updateservice.discountPercentage} 
                                                        ref={discountRef}
                                                        className="form-control"
                                                        id="discount"
                                                        
                                                        onChange={handleDiscountChange}
                                                        min="0"
                                                        max="100"
                                                        placeholder="Enter discount percentage"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                        )}<div className="form-check form-switch mb-3">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="toggleHomeService"
                                          onChange={handleToggleHomeService}
                                          checked={homeServiceEnabled ?? Updateservice.homeServiceEnabled}
                                        />
                                        <label className="form-check-label" htmlFor="toggleHomeService">
                                          Enable Home Service
                                        </label>
                                      </div>
                                      {homeServiceEnabled && (
                                        <div className="row mb-3">
                                          <label htmlFor="serviceCharge" className="col-sm-2 col-form-label">Service Charge:</label>
                                          <div className="col-sm-6">
                                            <input
                                              type="text"  value={ serviceCharge ?? Updateservice.serviceCharge} 
                                              ref={serviceChargeRef}
                                              className="form-control"
                                              id="serviceCharge"
                                              
                                              
                                              onChange={handleServiceChargeChange}
                                              min="0" max="100"
                                              placeholder="Enter service charge"
                                              required
                                            
                                            />
                                          </div>
                                        </div>
                                      )}
                                      

                                    </div>
                                    <div className="text-end">
                                        <Button className="right-button"
                                            variant="contained"
                                            color="primary"
                                            style={{
                            backgroundColor: '#02176D', color: 'white'
                          }} 
                                            onClick={handleAddService}
                                        // disabled={brands.length === 0}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </main>

            <footer id="footer" className="footer">
                <div className="copyright">
                    &copy; Copyright <strong><span>CarCrew+</span></strong>. All Rights Reserved
                </div>
            </footer>
        </div>
    )
};

export default EditServiceView;